import React from "react";
import "./Header.css";
import { HKNavbar } from "./NavBar";
import { Container } from "react-bootstrap";

export function Header() {
  const getDate = () => {
    return new Date().toLocaleString("nl-BE");
  };

  const getEventName = () => {
    return "IHC voetbal";
  };

  return (
    <>
      <Container>
        <HKNavbar />
      </Container>
      <div className="panorama" />
      <div className="nextEvent">
        <div className="hkcEvent p-1 pb-0">
          <h4>{getDate()}</h4>
          <h1>{getEventName()}</h1>
        </div>
      </div>
    </>
  );
}
